export enum Layout {
  DESKTOP = "desktop",
  TABLET = "tablet",
  MOBILE = "mobile",
  MOBILE_LANDSCAPE = "mobile-landscape",
  LAPTOP = "laptop",
}
